import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const BlikPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.BLIK_CHECKOUT}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.BLIK_CHECKOUT)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.BLIK)} alt="blik" />
    </Box>
  );
};
